module.exports = __webpack_public_path__ + "static/terminal--moonlight.cfe56e972a7c9c1cfa24982dd446a73c.jpg";